export default __webpack_public_path__ + "static/media/line-mobile-4.4e903dd2.svg";